import { createAction, props, union } from '@ngrx/store';

export const selectCustomer = createAction('[JobFilter] SELECT_CUSTOMER', props<{ customerId: number }>());
export const setFilterFormExpanded = createAction('[InvoiceFilter] SET_FILTER_FORM_EXPANDED', props<{ expanded: boolean }>());

export const InvoiceFilterActions = union({ selectCustomer, setFilterFormExpanded });
